import React from "react";
import Select from "react-select";

export default class SelectClass extends React.Component {
	state = {
		selectedOption: null,
		initialized: false,
	};

	componentDidUpdate(prevProps) {
		// Auto-select saved class if defaultValue is provided and options are loaded
		if (!this.state.initialized && this.props.defaultValue && this.props.listClass) {
			const options = this.props.listClass.filter(Boolean);
			const savedOption = options.find(opt => opt.value === this.props.defaultValue);
			if (savedOption) {
				this.setState({ selectedOption: savedOption, initialized: true });
			}
		}
	}

	handleChange = (selectedOption) => {
		this.setState({ selectedOption });
		this.props.onSelectClass(selectedOption);
	};

	render() {
		const { selectedOption } = this.state;
		const options = this.props.listClass
			? this.props.listClass.filter(Boolean)
			: [];

		return (
			<Select
				value={selectedOption}
				onChange={this.handleChange}
				options={options}
				placeholder="Pilih Kelas"
				isLoading={!this.props.listClass}
				noOptionsMessage={() => "Tidak ada data"}
				isSearchable={true}
			/>
		);
	}
}
